export async function sendMessage(thread, body) {
    const url = Routing.generate('imatic_communicator_thread_message', {thread: thread});

    const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({message: body}),
    });

    if (response.status === 401) {
        throw new Error("Unauthorised");
    } else if (response.status === 403) {
        throw new Error(response.statusText);
    }

    return response;
}

export async function getThreadEvents(thread, from, direction = 'next') {
    const url = Routing.generate('imatic_communicator_thread_events', {
        thread,
        from,
        direction,
    });

    try {

        const response = await fetch(url, {credentials: 'include'});

        if (response.status === 401) {
            location.reload(true);
        }

        return await response.json();
    } catch (e) {
        location.reload(true);
    }
}

export async function updateThreadOwner(thread, owner) {
    const url = Routing.generate('imatic_communicator_thread_edit', {
        thread: thread,
    });

    try {
        const response = await fetch(url, {
            credentials: 'include',
            method: 'POST',
            headers: {'Content-Type':'application/x-www-form-urlencoded'},
            body: `owner=${encodeURIComponent(owner)}`
        });

        if (response.status === 401) {
            location.reload(true);
        }
    } catch (e) {
        location.reload(true);
    }
}

export async function updateThreadWorkflowStatus(thread, workflowStatus) {
    const url = Routing.generate('imatic_communicator_thread_workflowstatusupdate', {
        thread,
        workflowStatus,
    });

    try {
        const response = await fetch(url, {credentials: 'include', method: 'POST'});

        if (response.status === 401) {
            location.reload(true);
        }

        return await response.json();
    } catch (e) {
        location.reload(true);
    }
}

export function uploadThreadFile(thread, file, onReadyStateChange) {
    return new Promise((resolve, reject) => {
        try {
            const xhr = new XMLHttpRequest();

            xhr.onreadystatechange = () => {
                onReadyStateChange(xhr.status, xhr.readyState);

                if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status === 401 || xhr.status === 0) {
                        location.reload();
                    }

                    resolve(xhr);
                }
            };

            xhr.open(
                'POST',
                Routing.generate('imatic_communicator_threadevent_file', {thread}),
                true,
            );

            xhr.withCredentials = true;

            xhr.setRequestHeader('Content-Type', file.type);
            xhr.setRequestHeader('Content-Disposition', 'attachment; filename="' + encodeURI(file.name) + '"');

            xhr.send(file);
        } catch (e) {
            reject(e);
        }
    })
}

export async function updateThreadNote(thread, newNote) {
    const url = Routing.generate('imatic_communicator_thread_edit', {
        thread: thread,
    });

    try {
        const response = await fetch(url, {
            credentials: 'include',
            method: 'POST',
            headers: {'Content-Type':'application/x-www-form-urlencoded'},
            body: `note=${encodeURIComponent(newNote)}`
        });

        if (response.status === 401) {
            location.reload(true);
        }
    } catch (e) {
        location.reload(true);
    }
}
